import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import Order from '../order/Order';
import RefundPolicy from './RefundPolicy';
import User from '../user/User';
import BillTransaction from '../payment/BillTransaction';
import DateTZ from '../date/DateTZ';
import RefundPaymentPassengers from './RefundPaymentPassengers';
import RefundPoliceRule from './RefundPoliceRule';

class RefundRequest extends ClassTimestampsHelper {
  constructor({ account, number, order, type, "for": forPay, initialDate, saveSalary, autoApproved, refundPolicy, reason, images = [],
    initiator, status, method, amount, user, meta, billTransaction, passengers = [], refundPolicyRule, errorMessage,
    rejectReason, approvedAt, lastTryAt
  } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.number = number;
    this.order = this.ref(order, Order);
    this.type = type; // RefundRequestType
    this.for = forPay; // RefundRequestFor
    this.initiator = this.obj(initiator, User);
    this.initialDate = this.obj(initialDate, DateTZ);
    this.saveSalary = !!saveSalary;
    this.method = method; // PaymentMethod
    this.amount = amount;
    this.user = this.obj(user, User);
    this.billTransaction = this.ref(billTransaction, BillTransaction);
    this.status = status; // RefundRequestStatus
    this.autoApproved = !!autoApproved;
    this.passengers = this.array(passengers, RefundPaymentPassengers);
    this.refundPolicy = this.ref(refundPolicy, RefundPolicy);
    this.refundPolicyRule = this.obj(refundPolicyRule, RefundPoliceRule);
    this.reason = reason;
    this.errorMessage = errorMessage;
    this.rejectReason = rejectReason;
    this.images = this.array(images, String);
    this.meta = this.obj(meta, Object);
    this.approvedAt = this.obj(approvedAt, DateTZ);
    this.lastTryAt = this.obj(lastTryAt, DateTZ);
  }
}

export default RefundRequest;